import { styled } from '@mui/material'
import MuiTableHead from '@mui/material/TableHead'
import { TableHeadProps } from './TableHead.types'

export const TableHead = styled(MuiTableHead)<TableHeadProps>`
  .MuiTableCell-root {
    border-top: 1px solid ${(props) => props.theme.palette.common.gray[600]};
    border-bottom: 1px solid ${(props) => props.theme.palette.common.gray[600]};
  }
`
